export const RESEND_COOLDOWN_SECONDS = 120 // 2 minutes

export function getBiometryResendTimerKey(projectId: string) {
  return `biometryResendCooldown:${projectId}`
}

export function getContractResendTimerKey(projectId: string) {
  return `contractResendCooldown:${projectId}`
}

export const STEP_KEYS = {
  BIOMETRY: 1,
  CONTRACT: 2,
  APPROVAL: 3,
  REPROVED: 4,
} as const

export const STEP_CONFIGURATION = {
  biometry: {
    id: 'biometry',
    textKey: 'customer.biometry.steps.biometry',
    status: 'waiting_biometry',
  },
  contract: {
    id: 'contract',
    textKey: 'customer.biometry.steps.contract',
    status: 'waiting',
  },
  approval: {
    id: 'approval',
    textKey: 'customer.biometry.steps.approval',
    status: 'waiting',
  },
  reproved: {
    id: 'reproved',
    textKey: 'customer.biometry.status.reproved',
    status: 'reproved',
  },
} as const

export interface TagItem {
  id: string
  text: string
  variant: 'fill'
  size: 'small'
  type: 'informative' | 'neutral' | 'warning' | 'negative' | 'positive'
}

export type TagsMap = Record<string, TagItem>

export function buildTags(t: (key: string, ...args: any[]) => string): TagsMap {
  return {
    sent_message: {
      id: 'sent_message',
      text: t('customer.biometry.status.sent_message'),
      variant: 'fill',
      size: 'small',
      type: 'informative',
    },
    waiting: {
      id: 'waiting',
      text: t('customer.biometry.status.waiting'),
      variant: 'fill',
      size: 'small',
      type: 'neutral',
    },
    waiting_biometry: {
      id: 'waiting',
      text: t('customer.biometry.status.waiting_biometry'),
      variant: 'fill',
      size: 'small',
      type: 'neutral',
    },
    in_progress: {
      id: 'in_progress',
      text: t('customer.biometry.status.in_progress'),
      variant: 'fill',
      size: 'small',
      type: 'warning',
    },
    under_analysis: {
      id: 'under_analysis',
      text: t('customer.biometry.status.under_analysis'),
      variant: 'fill',
      size: 'small',
      type: 'informative',
    },
    reproved: {
      id: 'reproved',
      text: t('customer.biometry.status.reproved'),
      variant: 'fill',
      size: 'small',
      type: 'negative',
    },
    accomplished: {
      id: 'accomplished',
      text: t('customer.biometry.status.accomplished'),
      variant: 'fill',
      size: 'small',
      type: 'positive',
    },
    signed: {
      id: 'signed',
      text: t('customer.biometry.status.signed'),
      variant: 'fill',
      size: 'small',
      type: 'positive',
    },
    completed: {
      id: 'completed',
      text: t('customer.biometry.status.approved'),
      variant: 'fill',
      size: 'small',
      type: 'positive',
    },
  }
}
